import {
	formatDate,
	formatChambre,
	formatCapitalize,
	formatCell,
	formatRow,
} from "../formatters";
import { VoteIcon } from "@logora/parliament.icons.regular_icons";
import { Label } from "@logora/parliament.ui.label";

export const formatCode = (item) => {
	if (!item.code) return null;
	const colorVariants = {
		success: "adopté",
		cancel: "rejeté",
	};
	return (
		<Label
			text={item.code.charAt(0).toUpperCase() + item.code.slice(1)}
			variantsObject={colorVariants}
			colorType={item.code}
		/>
	);
};

export const formatType = (item) => {
	let typeObjet = null;

	if (item.typeObjet === "amendement") {
		typeObjet = "Amendement";
	} else if (item.typeObjet === "motionCensure") {
		typeObjet = "Motion de censure";
	} else if (item.typeObjet === "motionRejet") {
		typeObjet = "Motion de rejet";
	} else if (item.typeObjet === "motionReferendaire") {
		typeObjet = "Motion référendaire";
	} else if (item.typeObjet === "article") {
		typeObjet = "Article";
	} else if (item.typeObjet === "projetLoi") {
		typeObjet = "Projet de loi";
	} else if (item.typeObjet === "propositionLoi") {
		typeObjet = "Proposition de loi";
	} else if (item.typeObjet === "propositionResolution") {
		typeObjet = "Proposition de résolution";
	}

	return <Label text={typeObjet} />;
};

const columns = [
	{
		header: "Chambre",
		accessorKey: "chambre",
		cell: (info) => formatChambre(formatCell(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Chambre",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{
						value: "AN",
						label: "AN",
					},
					{
						value: "SN",
						label: "SN",
					},
				],
			},
		},
	},
	{
		header: "Date",
		accessorKey: "dateScrutin",
		cell: (info) => formatDate(formatCell(info)),
		defaultSorting: "desc",
		meta: {
			filter: {
				label: "Date",
				variant: "date-range",
				labels: ["Après le", "Avant le"],
			},
		},
	},
	{
		header: "Type",
		accessorKey: "typeObjet",
		cell: (info) => formatType(formatRow(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Type",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "amendement", label: "Amendement" },
					{ value: "article", label: "Article" },
					{ value: "projetLoi", label: "Projet de loi" },
					{ value: "propositionLoi", label: "Proposition de loi" },
					{ value: "motionCensure", label: "Motion de censure" },
					{ value: "motionRejet", label: "Motion de rejet" },
					{ value: "motionReferendaire", label: "Motion référendaire" },
					{ value: "propositionResolution", label: "Proposition de résolution" },
				],
			},
		},
	},
	{
		header: "Objet",
		accessorKey: "titre",
		cell: (info) => formatCapitalize(formatCell(info)),
		enableSorting: false,
	},
	{ header: "Votes", accessorKey: "nombreVotants" },
	{
		header: "Résultat",
		accessorKey: "code",
		cell: (info) => formatCode(formatRow(info)),
		enableSorting: false,
		meta: {
			filter: {
				label: "Résultat",
				variant: "select",
				options: [
					{ value: null, label: "Tous" },
					{ value: "adopté", label: "Adopté" },
					{ value: "rejeté", label: "Rejeté" },
				],
			},
		},
	},
];

export const scrutinDataset = {
	key: "scrutins",
	name: "Scrutins",
	columns: columns,
	searchPlaceholder: "Rechercher un scrutin...",
	icon: <VoteIcon width={20} height={20} />,
};
